import repository from './repository';
import RoleRepository from './role.repository';
import axios from "axios";

let repo = repository('/users');

const API = process.env.VUE_APP_API_URL;
const passwordRegex = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){8,4096}$/;

// Simple function to get an empty user
repo.blankUser = () => {
    return {
        firstname: '',
        lastname: '',
        email: '',
        roles: [],
        password: '',
        passwordRepeat: '',
    };
};

repo.editPassword = (data) => {
    return axios.post(API + '/user/edit_password', data);
};

repo.GetAllRoles = () => {
    let options = [];
    RoleRepository.getAllRoles().then(res => {
        let Role = res.data["roles"];
        Role.forEach(role => {
            options.push({value: role.role, text: role.role})
        });
    });
    return JSON.stringify(options)
};

// Validation logic
function validateName(name) {
    return (name.length >= process.env.VUE_APP_VALIDATION_USER_MIN_NAME_LENGTH && name.length <= 250);
}

repo.validate = {
    firstName(name) {
        return validateName(name);
    },
    lastName(name) {
        return validateName(name);
    },
    email(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    },
    roles(roles) {
        return roles.length >= 1;
    },
    password(password) {
        return passwordRegex.test(password);
    },
    passwordRepeat(password, passwordRepeat) {
        return ((passwordRegex.test(passwordRepeat)) && (password === passwordRepeat));
    }
};

export default repo;
